import React, { useEffect, useState, useMemo } from "react"
import PropTypes from "prop-types"
import DataGridTable from "../../../../components/Table/data-grid-table"
import { useNavigate } from "react-router-dom"
import { MODULOS_CADASTRO_EVENTOS } from "../../CadastroEventos/cadastro-motor-eventos-const"
import MotorStatusCadastroService from "src/services/motor-status-cadastro-service"
import EventosService from "src/services/eventos_service"
import { dispatchSnackbar } from "src/v2/components/SnackBar/snackbar-bus"
import { MOTOR_EVENTOS_CADASTRO_PAGE, MOTOR_CADASTRO_MANUAL_PAGE } from "src/utils/routes"

const StatusAnaliticoCadastro = ({ cetip, versaoDocumento }) => {
    const [rows, setRows] = useState([])
    const [rowCount, setRowCount] = useState(0)
    const [loadingStatus, setLoadingStatus] = useState(false)
    const navigate = useNavigate()
    const statusService = useMemo(() => new MotorStatusCadastroService(), [])

    useEffect(() => {
        loadStatus(1, 25)
    }, [cetip, versaoDocumento])

    const loadStatus = async (page, pageSize) => {
        try {
            setLoadingStatus(true)
            const offset = (page - 1) * pageSize
            const response = await statusService.loadStatusCadastro(cetip, versaoDocumento, pageSize, offset)
            const { count, results } = response.body

            setRowCount(count)
            setRows(results.map((item, index) => ({
                id: offset + index,
                cetip: item.CETIP,
                rendaFixaCaracteristicasID: item.RendaFixaCaracteristicasID,
                versaoDocumento: item.VersaoDocumento,
                consolidado: item.StatusConsolidado,
                caracteristicas: formatModulo(item.Caracteristicas),
                parametros: formatModulo(item.Parametros),
                eventosOrdinarios: formatModulo(item.EventosOrdinarios),
                eventosExtraordinarios: formatModulo(item.EventosExtraordinarios),
            })))
        } catch (error) {
            console.error("Erro ao carregar status:", error)
        } finally {
            setLoadingStatus(false)
        }
    }

    const formatModulo = (modulo) => {
        if (!modulo) return null
        return `${modulo.Status}\n${modulo.Usuario}\nDtCriacao: ${modulo.CriadoEm}\nDtAtualizacao: ${modulo.AtualizadoEm}`
    }

    const handleNavigate = async (row, modulo) => {
        try {
            if (modulo === MODULOS_CADASTRO_EVENTOS.CARACTERISTICAS) {
                navigate(MOTOR_CADASTRO_MANUAL_PAGE, {
                    state: {
                        cetip: row.cetip,
                        versaoDocumento: row.versaoDocumento,
                        id: row.rendaFixaCaracteristicasID,
                    },
                })
                return
            }

            const eventosService = new EventosService()
            const response = await eventosService.getEventos(
                row.cetip,
                row.versaoDocumento,
                row.rendaFixaCaracteristicasID
            )
            const cadastros = response.body?.Cadastros ?? []
            const cadastro = cadastros[0]
            const status = cadastro?.Status ?? "Em andamento"

            navigate(MOTOR_EVENTOS_CADASTRO_PAGE, {
                state: {
                    RendaFixaCaracteristicasID: row.rendaFixaCaracteristicasID,
                    CETIP: row.cetip,
                    VersaoDocumento: row.versaoDocumento,
                    Status: status,
                    Data: cadastro,
                    Parametros: cadastro?.Parametros ?? null,
                    origem: "ver",
                    initialTab: modulo,
                },
            })
        } catch (error) {
            dispatchSnackbar("Erro ao carregar dados do cadastro", "error")
        }
    }

    const renderStatusCell = (value) => {
        if (!value) return "-"

        const lines = value.split("\n")

        return (
            <div style={{ lineHeight: "1.3" }}>
                <strong>{lines[0]}</strong>
                <div>{lines[1]}</div>
                <div style={{ fontSize: 11, color: "#666" }}>{lines[2]}</div>
                <div style={{ fontSize: 11, color: "#666" }}>{lines[3]}</div>
            </div>
        )
    }

    const renderClickableCell = (modulo) => {
        const Cell = (params) => (
            <div style={{ cursor: "pointer", width: "100%" }}
                onClick={() => handleNavigate(params.row, modulo)}
            >
                {renderStatusCell(params.value)}
            </div>
        )
        Cell.displayName = `ClickableCell_${modulo}`
        return Cell
    }

    const columns = () => [
        { field: "cetip", headerName: "CETIP", flex: 1 },
        { field: "versaoDocumento", headerName: "Ver. Doc.", flex: 1 },
        { field: "consolidado", headerName: "Consolidado", flex: 1 },

        {
            field: "caracteristicas",
            headerName: "Características",
            flex: 2,
            renderCell: renderClickableCell(MODULOS_CADASTRO_EVENTOS.CARACTERISTICAS),
        },
        {
            field: "parametros",
            headerName: "Parâmetros",
            flex: 2,
            renderCell: renderClickableCell(MODULOS_CADASTRO_EVENTOS.PARAMETROS),
        },
        {
            field: "eventosOrdinarios",
            headerName: "Ev. Ordinários",
            flex: 2,
            renderCell: renderClickableCell(MODULOS_CADASTRO_EVENTOS.EVENTOS_ORDINARIOS),
        },
        {
            field: "eventosExtraordinarios",
            headerName: "Ev. Extraord.",
            flex: 2,
            renderCell: renderClickableCell(MODULOS_CADASTRO_EVENTOS.EVENTOS_EXTRAORDINARIOS),
        },
    ]

    return (
        <DataGridTable
            rows={rows}
            columns={columns()}
            loading={loadingStatus}
            disableRowSelectionOnClick
            pointerCursor
            autoRowHeight
            serverSide
            rowCount={rowCount}
            onServerPageChange={(page, pageSize) => loadStatus(page, pageSize)}
        />
    )
}

StatusAnaliticoCadastro.propTypes = {
    cetip: PropTypes.string,
    versaoDocumento: PropTypes.string,
}

export default StatusAnaliticoCadastro